export const required = (value: unknown): string | undefined =>
  !value || (Array.isArray(value) && !value.length) ? 'Required' : undefined;
